import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Reception = lazy(() => import('@/pages/reception'));
const ReceptionList = lazy(() => import('@/pages/reception/ReceptionList'));
const ReceptionDetail = lazy(() => import('@/pages/reception/ReceptionDetail'));

// 리셉션 관리자 라우트 (관리자 전용, AppRouteLayout 하위 - 리셉션 모드 진입 불필요)
export const receptionRoutes: TypedRouteObject = {
	path: ROOTS.RECEPTION,
	element: withSuspense(Reception),
	handle: {
		title: '리셉션 관리',
		subTitle: '락앤런 트레일러닝 대회 리셉션 관리',
		permission: 'RECEPTION',
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />,
		},
		// 대회/프로그램 목록
		{
			path: paths.reception.list.path,
			element: withSuspense(ReceptionList),
			handle: {
				title: '락앤런 대회 리셉션 관리',
				subTitle: '락앤런 대회 진행 참가자 현황 및 관리',
			},
		},
		// 리셉션 현황 상세
		{
			path: paths.reception.detail.path,
			element: withSuspense(ReceptionDetail),
			handle: {
				isGoBack: true,
				title: '리셉션 현황',
				subTitle: '리셉션 > 대회/프로그램 목록 > 상세정보',
			},
		},
	],
};
